// extracted by mini-css-extract-plugin
module.exports = {"checkBoxLabel":"Checkbox_checkBoxLabel__2782t","customCheckbox":"Checkbox_customCheckbox__3uij7"};